import { useEffect, useState } from "react"
import { usePostType } from "@/lib/helpers/template"
import {
  usePathData,
  usePropsObject,
  useAdminBar
} from "@/lib/contexts/appContext"
import Main from "@/components/wrappers/main"
import Breadcrumbs from "@/components/base/breadcrumbs/breadcrumbs"
import Blocks from "@/components/Blocks"
import Byline from "@/common/article/byline"
import Card from "@/common/cards/article/article"
import CTA from "@/common/article/cta"
import Terms from "@/common/article/terms"
import SchoolSearchPanel from "@/common/school-search-panel/school-search-panel"
import Like from "@/common/social/like"
import Share from "@/common/social/share"
import styles from "./article.module.css"
import classNames from "classnames/bind"
import { pushDataLayer } from "@/lib/helpers/tagManager"
import { ArchiveProvider } from "@/lib/contexts/archiveContext"

export default function Article() {
  const object = usePropsObject()
  const pathData = usePathData()
  const postType = usePostType()
  const adminBar = useAdminBar()
  const cx = classNames.bind(styles)
  const [classes, setClasses] = useState({
    main: true
  })

  useEffect(() => {
    setClasses({
      ...classes,
      "has-search": postType === "school",
      "has-admin-bar": adminBar
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathData])

  const crumbs = [{ label: object.title, uri: null }]

  if (!object?.multipleParents) {
    const primary = object.terms
      .filter((term) => term.isPrimary === true)
      .shift()

    if (primary) {
      crumbs.unshift({ label: primary.label, uri: primary.url })
    }
  } else {
    object.terms
      .filter((term) => term.isParent === true)
      .map((term) => {
        crumbs.unshift({ label: term.label, uri: term.url })
      })
  }

  crumbs.unshift({ label: "Startsida", uri: "/" })

  useEffect(() => {
    pushDataLayer(object.tracking)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Main className={cx(classes)}>
      {postType === "school" && (
        <ArchiveProvider
          key={`school-${pathData.path}`}
          {...{ context: "school" }}>
          <SchoolSearchPanel search={object?.search} />
        </ArchiveProvider>
      )}
      <Breadcrumbs crumbs={crumbs} gap="none" />
      <article className={styles.article}>
        <Blocks blocks={pathData.content} />
      </article>
      <CTA data={object.cta} />
      <Terms
        terms={object.terms}
        className="px-4 mt-10 max-w-screen-sm sm:px-10 md:max-w-1xl"
      />
      {object?.showSocial && (
        <div className="box-content justify-between items-center px-4 mx-auto mt-6 mb-6 max-w-screen-sm sm:flex sm:px-10 md:max-w-1xl post-social no-print">
          <Like id={object.id} likes={object.likes} />
          <div className="flex">
            <Share
              classes="mt-4 sm:mt-0 mr-2 w-icon h-icon"
              url={object.url}
              sharing={object.sharing}
            />
          </div>
        </div>
      )}
      {object.byline && <Byline byline={object.byline} />}
      <Related object={object} />
    </Main>
  )
}

export const Related = ({ object }) => {
  if (!object.related) {
    return null
  }

  const related = object.related.posts.map((post, key) => {
    return (
      <li key={key}>
        <Card post={post} />
      </li>
    )
  })

  return (
    <div className={classNames(styles["related-wrapper"], "no-print")}>
      <h2 className="mb-8 text-xl sm:text-2xl lg:text-3xl">
        {object.related.label}
      </h2>
      <ul className="list">{related}</ul>
    </div>
  )
}
